const accordionTitles = document.querySelectorAll('.js-accordion__title');
const accordionContents = document.querySelectorAll('.js-accordion__content');

Array.from(accordionTitles).forEach((accordionTitle) => {
	accordionTitle.addEventListener('click', () => {
		accordionTitle.parentElement.classList.toggle('active');
	});
});

const setContentMaxHeight = () => {
	Array.from(accordionContents).forEach((accordionContent) => {
		accordionContent.style.setProperty('--max-height', `${accordionContent.scrollHeight}px`);
	});
};

setContentMaxHeight();

window.addEventListener('resize', setContentMaxHeight);
